import { render } from "./BulkAnalysisView.vue?vue&type=template&id=21270f78&scoped=true"
import script from "./BulkAnalysisView.vue?vue&type=script&lang=js"
export * from "./BulkAnalysisView.vue?vue&type=script&lang=js"

import "./BulkAnalysisView.vue?vue&type=style&index=0&id=21270f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21270f78"]])

export default __exports__